import type { RouteRecordRaw } from "vue-router";
import { wheneverOnceAsync } from "ls/composables/wheneverOnceAsync";
import { useAxureCloudConfig } from "ls/state/useAxureCloudConfig";
import { useRouter } from "vue-router";
import { domainPrefixParameterName, routeNames } from "../../router/constants";

export const enterpriseRoute: RouteRecordRaw = {
  path: "/asec",
  name: routeNames.enterprise,
  component: () => import("ls/features/enterprise/Enterprise.vue"),
  redirect: {
    name: routeNames.enterpriseCreate,
  },
  meta: {
    requiresAuth: false,
  },
  children: [
    {
      path: `create/:${domainPrefixParameterName}?`,
      name: routeNames.enterpriseCreate,
      component: () => import("ls/features/enterprise/EnterpriseCreate.vue"),
      props: true,
    },
    {
      path: `register/:${domainPrefixParameterName}`,
      name: routeNames.enterpriseRegister,
      component: () => import("ls/features/enterprise/EnterpriseRegister.vue"),
      props: true,
    },
  ],
};

export function useConfigureEnterpriseRoutes() {
  const router = useRouter();
  const config = useAxureCloudConfig();

  const stop = router.beforeEach(async to => {
    if (!to.path.startsWith(enterpriseRoute.path)) {
      return true;
    }

    if (router.hasRoute(routeNames.enterpriseCreate)) {
      stop();
      return true;
    }

    // Make sure that config is loaded
    const configValue = await wheneverOnceAsync(() => config.value);
    if (!configValue.SubInstancesSupported) {
      stop();
      return routeNames.notFound;
    }

    router.addRoute(enterpriseRoute);
    stop();
    return to.fullPath;
  });
}
